module.exports = __webpack_public_path__ + "static/media/star_gold.3f9ee2c1.svg";